import { Injectable, Inject, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { ElemCsoport } from '../modules';

@Injectable()
export class ConfigurationService {
  public NyilvantartasiModulInicializalva: EventEmitter<boolean> = new EventEmitter(true);

  private static configuration: IServerConfiguration;
  private originUrl: string;

  constructor(private http: HttpClient, @Inject('ORIGIN_URL') originUrl: string) {
    // ConfigurationService.configuration = <IServerConfiguration>({});
    // ConfigurationService.configuration.IdentityServer = 'http

    this.originUrl = originUrl;
  }

  loadConfig() {
    return this.http.get<IServerConfiguration>('/api/Configuration')
    .toPromise()
    .then(result => {
      ConfigurationService.configuration = <IServerConfiguration>(result);
      if (ConfigurationService.configuration.RiportModul) {
        ConfigurationService.configuration.RiportModulConfiguration = JSON.parse(ConfigurationService.configuration.RiportModul);
      }
      if (ConfigurationService.configuration.NyilvantartasiModul) {
        ConfigurationService.configuration.NyilvantartasiModulConfiguration = JSON.parse(ConfigurationService.configuration.NyilvantartasiModul);
      }
      if (ConfigurationService.configuration.Feladatkosar) {
        ConfigurationService.configuration.FeladatkosarConfiguration = JSON.parse(ConfigurationService.configuration.Feladatkosar);
      }
      if (ConfigurationService.configuration.Alkalmazasok) {
        ConfigurationService.configuration.AlkalmazasokConfiguration = JSON.parse(ConfigurationService.configuration.Alkalmazasok);
      }
    }
    , error => {
      console.error(error);
    });

  }

  get identityServerAddress() {
    if (ConfigurationService.configuration.IdentityServer && ConfigurationService.configuration.IdentityServer.startsWith('/')) {
      return this.originUrl + ConfigurationService.configuration.IdentityServer.substr(1);
    } else {
      return ConfigurationService.configuration.IdentityServer;
    }
  }

  get profileManagementAddress() { return ConfigurationService.configuration.ProfileManagement; }
  get organizationManagementAddress() { return ConfigurationService.configuration.OrganizationManagement; }
  get labelManagementAddress() { return ConfigurationService.configuration.LabelManagement; }
  get roleManagementAddress() { return ConfigurationService.configuration.RoleManagement; }
  get assignmentManagementAddress() { return ConfigurationService.configuration.AssignmentManagement; }
  get userManagementAddress() { return ConfigurationService.configuration.UserManagement; }
  get codeListManagementAddress() { return ConfigurationService.configuration.CodeListManagement; }
  get formManagementAddress() { return ConfigurationService.configuration.FormManagement; }
  get dataEntryManagementAddress() { return ConfigurationService.configuration.DataEntryManagement; }
  get internalMessageManagementAddress() { return ConfigurationService.configuration.InternalMessageManagement; }
  get maintenanceMessageManagementAddress() { return ConfigurationService.configuration.MaintenanceMessageManagement; }
  get portalMessageManagementAddress() { return ConfigurationService.configuration.PortalMessageManagement; }
  get helpMessageManagementAddress() { return ConfigurationService.configuration.HelpMessageManagement; }
  get changeManagementAddress() { return ConfigurationService.configuration.ChangeManagement; }
  get workflowManagementAddress() { return ConfigurationService.configuration.WorkflowManagement; }
  get caseManagementAddress() { return ConfigurationService.configuration.CaseManagement; }
  get kpiManagementAddress() { return ConfigurationService.configuration.KPIManagement; }
  get bulletinManagementAddress() { return ConfigurationService.configuration.BulletinManagement; }
  get faqMessageManagementAddress() { return ConfigurationService.configuration.FaqMessageManagement; }
  get validationManagementAddress() { return ConfigurationService.configuration.ValidationManagement; }
  get batchManagementAddress() { return ConfigurationService.configuration.BatchManagement; }
  get notificationManagementAddress() { return ConfigurationService.configuration.NotificationManagement; }
  get customPropManagementAddress() { return ConfigurationService.configuration.CustomPropManagement; }
  get officialActManagementAddress() { return ConfigurationService.configuration.OfficialActManagement; }
  get inspectionManagementAddress() { return ConfigurationService.configuration.InspectionManagement; }
  get backendForFrontendAddress() { return ConfigurationService.configuration.BackendForFrontend; }
  get secGroupManagementAddress() { return ConfigurationService.configuration.SecGroupManagement; }
  get universalModuleAddress() { return ConfigurationService.configuration.UniversalModule; }

  get watermark() { return ConfigurationService.configuration.Watermark; }
  get validationMode() { return ConfigurationService.configuration.ValidationMode; }
  get treatAllFieldsAsRequired() { return ConfigurationService.configuration.TreatAllFieldsAsRequired === 'true'; }
  get issuer() { return ConfigurationService.configuration.Issuer; }
  get releaseDate() { return ConfigurationService.configuration.ReleaseDate; }
  get visualFeatures() { return ConfigurationService.configuration.VisualFeatures; }
  get numberOfDigitsToRound() { return ConfigurationService.configuration.NumberOfDigitsToRound; }
  get orgFormCrossFilter() { return ConfigurationService.configuration.OrgFormCrossFilter; }
  get releaseNotesUrl() { return ConfigurationService.configuration.ReleaseNotesUrl; }
  get nyilvantartasiModul() { return ConfigurationService.configuration.NyilvantartasiModul; }
  get nyilvantartasiModulConfiguration() { return ConfigurationService.configuration.NyilvantartasiModulConfiguration; }
  get riportModul() { return ConfigurationService.configuration.RiportModul; }
  get riportModulConfiguration() { return ConfigurationService.configuration.RiportModulConfiguration; }
  get feladatkosar() { return ConfigurationService.configuration.Feladatkosar; }
  get feladatkosarConfiguration() { return ConfigurationService.configuration.FeladatkosarConfiguration; }
  get alkalmazasok() { return ConfigurationService.configuration.Alkalmazasok; }
  get alkalmazasokConfiguration() { return ConfigurationService.configuration.AlkalmazasokConfiguration; }
  get gitHash() { return ConfigurationService.configuration.GitHash; }
  get gitDate() { return ConfigurationService.configuration.GitDate; }
}

export interface IServerConfiguration {
  ProfileManagement: string;
  OrganizationManagement: string;
  LabelManagement: string;
  RoleManagement: string;
  AssignmentManagement: string;
  UserManagement: string;
  CodeListManagement: string;
  FormManagement: string;
  DataEntryManagement: string;
  InternalMessageManagement: string;
  MaintenanceMessageManagement: string;
  PortalMessageManagement: string;
  HelpMessageManagement: string;
  ChangeManagement: string;
  WorkflowManagement: string;
  CaseManagement: string;
  KPIManagement: string;
  BulletinManagement: string;
  FaqMessageManagement: string;
  ValidationManagement: string;
  BatchManagement: string;
  NotificationManagement: string;
  CustomPropManagement: string;
  OfficialActManagement: string;
  InspectionManagement: string;
  SecGroupManagement: string;
  BackendForFrontend: string;
  UniversalModule: string;
  IdentityServer: string;

  Watermark: string;
  ValidationMode: string;
  TreatAllFieldsAsRequired: string;
  Issuer: string;
  ReleaseDate: string;
  VisualFeatures: string;
  NumberOfDigitsToRound: number;
  OrgFormCrossFilter: string;

  ReleaseNotesUrl: string;

  NyilvantartasiModul: string;
  RiportModul: string;
  Feladatkosar: string;
  Alkalmazasok: string;

  NyilvantartasiModulConfiguration: NyilvantartasiModulConfiguration;
  RiportModulConfiguration: RiportModulConfiguration;
  FeladatkosarConfiguration: FeladatkosarConfiguration;
  AlkalmazasokConfiguration: AlkalmazasokConfiguration;

  GitHash: string;
  GitDate: string;
}

export class NyilvantartasiModulConfiguration {
  initialized: Promise<boolean>;

  engedelyezve: boolean;
  felirat: string;

  nyilvantartasok: NyilvantartasConfiguration[];
  menucsoportok: ElemCsoport[];
}

export class NyilvantartasConfiguration {
  azonosito: string;
  megnevezes: string;
  
  csoportSorrend: number;
  csoportFelirat: string;
  csoportIkon: string;
  sorrend: number;
  felirat: string;
  ikon: string;
  jogosultsagMezo: string;
  feliratKifejezes: string;
  rendezesiSorrend: string;
  szerepkor: string;
  
  virtualis: boolean;
  rejtett: boolean;
} 

export class AlkalmazasokConfiguration {
  engedelyezve: boolean;
  alkalmazasok: AlkalmazasConfiguration[];
}

export class AlkalmazasConfiguration {
  megnevezes: string;
  ikon: string;
  szin: string;
  szerepkor: string;
  menuk: string[];
  riportok: string[];
  nyilvantartasok: string[];
  feladatkosarak: string[];
  alapertelmezett: boolean;
  route: string;
  felhasznaloLathatja: boolean;
} 

export class RiportModulConfiguration {
  engedelyezve: boolean;
  felirat: string;
  riportmappak: RiportMappaConfiguration[];
}

export class RiportMappaConfiguration {
  felirat: string;
  ikon: string;
  url: string;
  viewer: string;
  path: string;
} 

export class FeladatkosarConfiguration {
  feladatTipusok: FeladatkosarTipusConfiguration[];
}

export class FeladatkosarTipusConfiguration {
  id: string;
  tipus: string;
  felirat: string;
  ikon: string;
} 



// WEBPACK FOOTER //
// ./src/app/configuration/configuration.service.ts